import React, { } from 'react'
import Posts from "../Updates/Posts"


export default function Notice({ location, navigate }) {
    return <Posts contentsName={"Notice"} location={location} navigate={navigate} />
}